import { CustomCodeSection } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { TextareaField } from '@frontend/design-system';
import { useSettingsForm } from '../../content-composer/hooks/use-settings-form';
import { SettingsPanel } from '../../content-composer/settings-panel/settings-panel';

export const CustomCodeSettings = () => {
  const { t } = useTranslation('content-composer');

  const { getFieldProps } = useSettingsForm<CustomCodeSection>({
    code: { type: 'text' },
  });

  return (
    <SettingsPanel>
      <SettingsPanel.Header>{t('Custom Code')}</SettingsPanel.Header>
      <SettingsPanel.Body
        css={{
          '& > div': {
            display: 'flex',
            flex: 1,
          },
        }}
      >
        <TextareaField
          {...getFieldProps('code')}
          css={{
            display: 'flex',
            flex: 1,
            height: 'auto',
            padding: theme.spacing(1),
          }}
        />
      </SettingsPanel.Body>
    </SettingsPanel>
  );
};
